<template>
  <div class="warpper">
    <div class="container">
      <crumb />
      <div class="lg">
        <div class="left_nav">
          <div class="nav_title">
            <div class="title_bg">
              {{ classTitle }}
              <div class="title_arr"></div>
            </div>
          </div>
          <ul class="nav_item">
            <li
              :class="item.id === setIndex ? 'on' : ''"
              v-for="(item, index) in smallClassList"
              :key="index"
              @click="productItem(item.id)"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>
        <div class="right_con">
          <ul
            class="nat_lisst"
            v-infinite-scroll="load"
            infinite-scroll-disabled="disabled"
          >
            <li
              v-for="item in ProductList"
              :key="item.id"
              @click="goDetail(item.id)"
            >
              <el-image :src="item.smallPhoto" contain lazy></el-image>
            </li>
          </ul>
          <div class="view_load">
            <div class="" v-if="loading">加载中...</div>
            <div class="" v-if="noMore">没有更多了</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import crumb from '../../components/bread-crumb/Index.vue'
import { ref, onMounted, reactive, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { posts } from '../../utils/posts'
import { useStore } from 'vuex'
// import { posts } from '../../utils/posts'
export default {
  name: '产品中心二级分类列表',
  components: {
    crumb
  },
  setup () {
    const classTitle = ref('')
    const route = useRoute()
    const classId = ref(0)
    const store = useStore()
    const router = useRouter()
    const user = store.state.userInfo || { uid: 0 }
    const ProductList = ref([])
    const setIndex = ref(0)
    const list = ref([])
    const count = ref(1)
    const state = reactive({
      // 搜索商品参数
      page: 1,
      pageSize: 16,
      search: 0,
      buildId: 0,
      smallClassId: 0,
      orderBy: 0,
      count: 1, // 当前页面数
      pageCount: 0, // 总页面数
      totalCount: 0 // 产品总数
    })
    classId.value = route.query.middleClassId // 中类ID
    state.smallClassId = route.query.smallClassId

    classTitle.value = route.query.name
    const smallClassList = ref([]) // 获取小类列表
    const noMore = computed(() => count.value >= state.pageCount)
    const disabled = computed(() => loading.value || noMore.value)
    const loading = ref(false)

    const getSmallClass = () => {
      posts('classes/getSmallClass', { middleClassId: classId.value }).then(
        (res) => {
          smallClassList.value = res.data
          setIndex.value = route.query.smallClassId * 1
          ProducHandler()
        }
      )
    }

    // 小类获取商品
    const productItem = (val) => {
      setIndex.value = val
      const title = smallClassList.value.filter((item) => item.id === val)
      classTitle.value = title[0].name
      state.smallClassId = val
      ProductList.value = []
      ProducHandler()
    }
    // 滚动加载
    const load = () => {
      loading.value = true
      count.value++
      ProducHandler()
      loading.value = false
    }

    // 获取商品列表
    const ProducHandler = () => {
      posts('product/getProducts/' + user.uid, {
        page: count.value,
        pageSize: state.pageSize,
        buildId: state.buildId,
        smallClassId: state.smallClassId,
        orderBy: state.orderBy
      }).then((res) => {
        state.totalCount = res.totalCount
        state.pageCount = res.pageCount
        list.value = ProductList.value.concat(res.data)
        ProductList.value = list.value
        loading.value = false
      })
    }
    const goDetail = (id) => {
      router.push({ path: '/product/detail', query: { pid: id } })
    }
    onMounted(() => {
      getSmallClass()
    })
    return {
      goDetail,
      state,
      count,
      load,
      list,
      noMore,
      loading,
      disabled,
      ProductList,
      ProducHandler,
      classTitle,
      productItem,
      getSmallClass,
      smallClassList,
      setIndex
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  width: 1200px;
}
.lg {
  display: flex;
  justify-content: space-between;
  margin: 36px 0 0 0;
}
.right_con {
  width: 970px;
  margin: 36px 0 0 0;
}
.nat_lisst {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
  li {
    width: 218px;
    height: 218px;
    overflow: hidden;
    border-radius: 10px;
    margin: 0 12px 24px 12px;
    cursor: pointer;
    transition: all 0.5s ease 0s;
    &:hover {
      transform: scale(1.05);
    }
  }
}
.nav_item {
  margin: 36px 0 0 0;
  li {
    height: 24px;
    font-size: 16px;
    font-weight: 600;
    line-height: 21px;
    color: #666666;
    margin: 0 0 12px 0;
    cursor: pointer;
    &:hover {
      font-size: 18px;
      font-weight: 600;
      line-height: 24px;
      color: #3e3a39;
    }
    &.on {
      font-size: 18px;
      font-weight: 600;
      line-height: 24px;
      color: #3e3a39;
    }
  }
}
.nav_title {
  font-size: 34px;
  font-weight: 600;
  line-height: 46px;
  color: #3e3a39;
  .title_bg {
    padding: 0 20px;
    height: 64px;
    line-height: 64px;
    text-align: center;
    background: linear-gradient(90deg, #ff5e41 0%, #fc4353 100%);
    opacity: 1;
    border-radius: 5px;
    color: white;
    position: relative;
    &::before {
      position: absolute;
      content: "";
      width: 14px;
      height: 14px;
      background: linear-gradient(90deg, #ff5e41 0%, #fc4353 100%);
      left: 0;
      right: 0;
      bottom: -7px;
      margin: auto;
      transform: rotate(45deg);
    }
  }
}
.view_load {
  width: 100%;
  flex-shrink: 0;
  text-align: center;
  box-sizing: border-box;
  padding: 15px 0;
  color: #ccc;
  font-size: 14px;
}
</style>
